import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Delete from '../../assets/person-dash.svg';
import { contactsAPI } from "../../API/api";
import { closeMenu, setTempChat } from "../../store/slices/appSlice";
import { useAppDispatch } from "../../hooks/hook";
const ListItem = ({ user, currentUserEmail }) => {
    const removeFromBlacklist = () => {
        contactsAPI.removeFromBlacklist(currentUserEmail, user);
    };
    const dispatch = useAppDispatch();
    const handleClickName = () => {
        dispatch(closeMenu(null));
        dispatch(setTempChat(user));
    };
    return (_jsxs("li", { style: { margin: '4px 8px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }, children: [_jsx("span", { onClick: handleClickName, style: { fontSize: '1.1rem', margin: '2px 0px', cursor: 'pointer' }, children: user.displayName }), _jsx("div", { title: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0438\u0437 \u0427\u0421", onClick: removeFromBlacklist, style: { display: 'flex', alignItems: 'center' }, children: _jsx(Delete, { color: "red", cursor: 'pointer' }) })] }));
};
export default ListItem;
